import { useQuery } from "@tanstack/react-query";
import { GetVendorParams } from "./vendor.types";
import { VENDOR_KEYS } from "./vendor.keys";
import { vendorService } from "./vendor.services";

export const useGetVendors = (params?: GetVendorParams) => {
  return useQuery({
    queryKey: VENDOR_KEYS.GET_VENDORS(params),
    queryFn: () => vendorService.getVendors(params),
  });
};
